
export const state = {
  detailId: null,
  numPatente: null,
  filter: {},
  gastos: {}
};
export const mutations = {
  update(state, id) {
    state.detailId = id;
  },
  updateFilter(state, filter) {
    state.filter = filter
  },
  updatePatente(state, patente) {
    state.numPatente = patente;
  },
  updateGastos(state, gastos) {
    state.gastos = gastos;
  }
};
export const getters = {
  detailId: state => state.detailId,
  detailPatente: state => state.numPatente,
  filter: state => state.filter,
  gastos: state => state.gastos
};
export const actions = {
  updateId({ commit }, id) {
    try {
      commit('update', id);
    } catch (e) {
      return console.log(e)
    }
  },
  updateFilter({ commit }, filter) {
    try {
      commit('updateFilter', filter);
    } catch (e) {
      return console.log(e)
    }
  },
  updatePatente({ commit }, patente) {
    try {
      commit('updatePatente', patente);
    } catch (e) {
      return console.log(e)
    }
  },
  updateGastos({ commit }, gastos) {
    try {
      commit('updateGastos', gastos);
    } catch (e) {
      return console.log(e)
    }
  }
};
